import React from "react";
import { Spinner } from "react-bootstrap";

type ButtonProps = {
  className?: string;
  loading?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  type?: "reset" | "submit" | "button";
};

export const Button: React.FC<ButtonProps> = ({
  loading = false,
  onClick,
  className,
  children = "Submit",
  type,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={className}
      style={{ minWidth: "7rem" }}
      type={type}
    >
      {loading ? (
        <Spinner animation="border" color="light" size="sm" />
      ) : (
        children
      )}
    </button>
  );
};
